import { makeActionCreator } from '../../utils/actionsUtils';
import {
    FILTER_PARTNER_ON_FIRST_LETTER,
    FILTER_PARTNER_ON_CATEGORY,
    SORT_PARTNER_ON_NAME,
    SORT_PARTNER_ON_CASHBACK,
    SORT_PARTNER_ON_ORDER,
    SORT_PARTNER_ON_CREATION_DATE,
    CLEAR_FILTER,
    CLEAR_SORT,
    SORT_PARTNER_ON_NB_COUPON
} from './constants';

export const filterPartnerOnFirstLetter = makeActionCreator(
    FILTER_PARTNER_ON_FIRST_LETTER,
    'page',
    'letter'
);
export const filterPartnerOnCategory = makeActionCreator(
    FILTER_PARTNER_ON_CATEGORY,
    'page',
    'category'
);
export const sortPartnerOnName = makeActionCreator(SORT_PARTNER_ON_NAME, 'page');
export const sortPartnerOnCashback = makeActionCreator(SORT_PARTNER_ON_CASHBACK, 'page');
export const sortPartnerOnOrder = makeActionCreator(SORT_PARTNER_ON_ORDER, 'page');
export const sortPartnerOnCreationDate = makeActionCreator(SORT_PARTNER_ON_CREATION_DATE, 'page');
export const sortPartnerOnNbCoupon = makeActionCreator(SORT_PARTNER_ON_NB_COUPON, 'page');

export const clearFilter = makeActionCreator(CLEAR_FILTER, 'page');
export const clearSort = makeActionCreator(CLEAR_SORT, 'page');



// WEBPACK FOOTER //
// ./src/services/filter/actions.js